module.exports = __webpack_public_path__ + "img/bin-c-5-w.fbed52cd.svg";